<template>
  <section class="azul1">
    <v-container id="container" class="py-15">
      <v-row align="center" justify="center" class="my-md-15">
        <v-col cols="10" class="pa-5">
          <h2 class="font-weight-bold mb-4 primary--text">
            ¿Qué son las cookies?
          </h2>
          <div class="hr accent"></div>
          <p class="font-weight-light mt-4 primary--text">
            Las “cookies” son pequeños ficheros temporales que se crean en el
            dispositivo del usuario (ordenador, teléfono, tableta, etc.) cuando
            visita una web, y que permiten a la misma almacenar información, por
            ejemplo para guardar sus preferencias de uso o para reconocerle en
            posteriores visitas. <br /><br />
            Cuando una web crea una cookie en el dispositivo del usuario, se
            almacena lo siguiente: <br />

            <v-list dense color="transparent">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >La dirección/dominio de la web que ha creado la cookie
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >La duración de la cookie, que puede ir de escasos minutos a
                  varios años
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>El contenido de la cookie. </v-list-item-text>
              </v-list-item>
            </v-list>

            El usuario puede en todo momento configurar su programa de
            navegación para impedir (bloquear) el uso de cookies por parte de
            determinadas webs, así como borrar las cookies almacenadas
            previamente.
          </p>
        </v-col>
        <v-col cols="10" class="pa-5">
          <h2 class="font-weight-bold mb-4 primary--text">
            ¿Para qué se usan las cookies?
          </h2>
          <div class="hr accent"></div>
          <br />
          <p class="font-weight-light mt-4 primary--text">
            <v-list dense color="transparent">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >Cookies técnicas esenciales. Se utilizan para gestionar el
                  flujo de navegación dentro de la web o para mantener al
                  usuario conectado a la misma. Al deshabilitarlas, es posible
                  que algún apartado de la web no funcione correctamente.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >Cookies de personalización. Necesarias para recordar
                  determinadas preferencias del usuario.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >Cookies analíticas. Nos ayudan a nosotros y a terceros a
                  recopilar información de la procedencia de los usuarios y su
                  navegación dentro de la web, a efectos de realizar un análisis
                  estadístico para poder mejorar la estructura y los contenidos.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >Cookies publicitarias. Utilizadas para gestionar los anuncios
                  que aparecen en la web, decidir el contenido o la frecuencia
                  de los anuncios.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >Cookies publicitarias comportamentales. Ayudan a recopilar
                  los hábitos de navegación del usuario para crear un perfil de
                  sus intereses y para mostrarle anuncios adaptados a los
                  mismos.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >Cookies para compartición social. Son necesarias para
                  identificar al usuario en sus redes sociales y así permitirle
                  compartir contenidos.
                </v-list-item-text>
              </v-list-item>
            </v-list>
          </p>
        </v-col>
        <v-col cols="10" class="pa-5">
          <h2 class="font-weight-bold mb-4 primary--text">
            ¿Qué es el almacenamiento local?
          </h2>
          <div class="hr accent"></div>
          <br />
          <p class="font-weight-light mt-4 primary--text">
            Por almacenamiento local entendemos cualquier fichero creado por la
            web en tu dispositivo de navegación. Las cookies son una forma de
            almacenamiento local, pero existen otras, por ejemplo:
            <v-list dense color="transparent">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >El almacenamiento local del navegador. Algunas webs utilizan
                  almacenamientos locales llamados “sessionStorage” y
                  “localStorage” para guardar información; “sessionStorage” se
                  borra automáticamente cuando se cierra el programa navegador;
                  en cambio para borrar el “localStorage” el usuario debe borrar
                  el historial del navegación.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >El almacenamiento local de Flash (“Flash Local Shared
                  Objects”). Flash es un complemento del navegador que permite
                  incorporar elementos interactivos y multimedia en una web.
                  Flash también permite a la web visitada almacenar ficheros en
                  el dispositivo del usuario.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >El almacenamiento local de Silverlight (“Isolated Objects”).
                  Silverlight es un complemento del navegador que permite
                  incorporar elementos interactivos y multimedia en una web.
                  Silverlight también permite a la web visitada almacenar
                  ficheros en el dispositivo del usuario.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >El web beacon es una técnica de rastreo que consiste en
                  insertar en la web o en un correo electrónico una imagen
                  alojada en un servidor de Internet de forma que, cuando el
                  navegador o programa de correo se conecta a dicho servidor
                  para descargar y visualizar la imagen, se registre el acceso.
                  A veces estas imágenes son muy pequeñas o transparentes de
                  forma que el usuario no se percata de su existencia.
                </v-list-item-text>
              </v-list-item>
            </v-list>
          </p>
        </v-col>
        <v-col cols="10" class="pa-5">
          <h2 class="font-weight-bold mb-4 primary--text">
            ¿Qué son las cookies de terceros?
          </h2>
          <div class="hr accent"></div>
          <br />
          <p class="font-weight-light mt-4 primary--text">
            Muchas webs incorporan funciones o características proporcionadas
            por terceros, como por ejemplo:
            <v-list dense color="transparent">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >Analíticas de acceso y uso de las páginas.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>Mapas interactivos. </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  >Vídeos y otros elementos multimedia.
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>Botones sociales. </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text>Publicidad. </v-list-item-text>
              </v-list-item>
            </v-list>
            El proveedor de una función o característica puede hacer uso de
            cookies y otras tecnologías de almacenamiento local en base a sus
            propios criterios y finalidades. Algunos proveedores utilizan
            cookies y otras tecnologías de rastreo para recopilar información
            sobre los hábitos de navegación del usuario con el objetivo de
            mostrarle publicidad adaptada a sus intereses. <br />
            <br />
            Navegar por esta web con las cookies y almacenamiento local
            activados conlleva necesariamente la aceptación de las políticas de
            privacidad establecidas por los proveedores de las siguientes
            funciones o características:
          </p>

          <v-simple-table class="transparent">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">COOKIE (Y PROVEEDOR)</th>
                  <th class="text-left">DURACIÓN</th>
                  <th class="text-left">DESCRIPCIÓN</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in desserts" :key="item">
                  <td>{{ item.proveedor }}</td>
                  <td>{{ item.duracion }}</td>
                  <td>{{ item.descripcion }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <br><p class="font-weight-light mt-4 primary--text">Si desea más información más sobre los tipos de cookies de seguimiento y análisis de datos de Google <a href="https://policies.google.com/technologies/cookies?hl=es&gl=es#types-of-cookies">haga clic aquí</a>. <br> <br>Para informarse sobre cómo eliminar las cookies de su explorador: <br>
          <v-list dense color="transparent">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  ><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias"> Firefox </a>
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text><a href="https://support.google.com/chrome/answer/95647?hl=es"> Chrome </a> </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text
                  ><a href="https://support.microsoft.com/es-es/topic/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d"> Internet Explorer </a>
                </v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text> <a href="https://support.apple.com/kb/PH19214?viewlocale=es_ES&locale=es_ES"> Safari </a></v-list-item-text>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-circle-medium </v-icon>
                </v-list-item-icon>
                <v-list-item-text><a href="https://www.allaboutcookies.org/es/administrar-las-cookies/opera.html"> Opera </a> </v-list-item-text>
              </v-list-item>
            </v-list>
            <br>
            NOTA: la información ofrecida es a fecha 29/04/2021 y le informamos que con el paso del tiempo puede no resultar exhaustiva, a pesar de que periódicamente la presente política de cookies es revisada.
            </p>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  proveedor: "Coockies",
  data() {
    return {
      desserts: [
        {
          proveedor: "__cfduid (notin.es)",
          duracion: "Sesión",
          descripcion: "Publicidad",
        },
        {
          proveedor: "personalization_id (twitter.com)",
          duracion: "Sesión",
          descripcion: "Twitter",
        },
        {
          proveedor: "Facebook",
          duracion: "Publicidad, estadísticas y mediciones",
          descripcion: "Coloca Cookies en el ordenador o dispositivo y recibe la información almacenada en ellas cuando utilizas o visitas servicios prestados por otras empresas que utilizan los servicios de Facebook.",
        },
        {
          proveedor: "_ga (Google)",
          duracion: "	2 años",
          descripcion: "Se usa para distinguir a los usuarios.",
        },
        {
          proveedor: "_gid (Google)",
          duracion: "24 horas",
          descripcion: "Se usa para distinguir a los usuarios.",
        },
        {
          proveedor: "_gat (Google)",
          duracion: "	1 minuto",
          descripcion: "	Se usa para limitar el porcentaje de solicitudes. Si has implementado Google Analytics mediante Google Tag Manager, esta cookie se llamará _dc_gtm_<property-id>.",
        },
        {
          proveedor: "_gali (Google)",
          duracion: "	30s",
          descripcion: "Atribución de enlace mejorada.",
        },
        {
          proveedor: "_unam (SHARETHIS)",
          duracion: "Persistente",
          descripcion: "	Su finalidad es cuantificar el número de Usuarios que comparten un determinado contenido y cuántas páginas web son visitadas a raíz de esa acción.",
        },
        {
          proveedor: "WordPress",
          duracion: "	2 años",
          descripcion: "	Utilizado para el correcto funcionamiento del gestor de contenido WordPress.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.hr {
  border-top: 3px solid;
  width: 3vw;
}
</style>